import { useState } from "react";
import {
  Box,
  Dialog,
  DialogContent,
  ImageList,
  ImageListItem,
  Typography,
} from "@mui/material";
import ImageWithLoader from "../../../common-components/ImageWithLoader";

// Thumbnails of an order's evidence photos (payment proofs, proof of
// delivery) with a click-to-enlarge lightbox.
const ProofImages = ({ title, images }) => {
  const [lightbox, setLightbox] = useState(null);
  if (!images?.length) return null;
  return (
    <Box mb={2}>
      <Typography variant="subtitle2" fontWeight={600} mb={1}>
        {title}
      </Typography>
      <ImageList cols={3} gap={8}>
        {images.map((url, i) => (
          <ImageListItem
            key={i}
            sx={{ cursor: "pointer" }}
            onClick={() => setLightbox(url)}
          >
            <ImageWithLoader
              src={url}
              alt={`proof-${i}`}
              loading="lazy"
              sx={{ height: 100, borderRadius: "4px" }}
            />
          </ImageListItem>
        ))}
      </ImageList>
      <Dialog open={!!lightbox} onClose={() => setLightbox(null)} maxWidth="md">
        <DialogContent sx={{ p: 0 }}>
          <ImageWithLoader
            src={lightbox}
            alt="proof"
            objectFit="contain"
            sx={{ width: "100%", height: { xs: 320, md: 480 } }}
          />
        </DialogContent>
      </Dialog>
    </Box>
  );
};

export default ProofImages;
